import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => {
  return ({
    brandedDocument: {
      borderRadius: 'var(--border-radius-lg)',
      minHeight: '150px',
      width: '220px',
      maxWidth: '220px',
      padding: 'var(--padding-sm)',
      border: 'var(--dai-border1)',
      boxShadow: 'var(--shadow-sm)',
      backgroundColor: 'var(--dai-color-input)',
      backgroundImage: ({ imageUrl }) => imageUrl ? `url(${imageUrl})` : undefined,
      backgroundPosition: 'center 25%',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      transition: 'all .3s ease',
      '& > *:hover': {
        textDecoration: 'none !important'
      },
      '&:hover': {
        boxShadow: 'var(--shadow-md)',
        borderColor: 'var(--dai-color-accent) !important',
        '& .__ds-title': {
          // height: '54px'
          backgroundColor: 'var(--dai-color-accent) !important'
        }
      },

      '& .__ds-title': {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        bottom: -2,
        left: 0,
        height: 'var(--font-size-lg)',
        color: 'var(--dai-contrast-accent)',
        backgroundColor: 'color-mix(in srgb, var(--dai-color-accent) 80%, transparent)',
        width: '220px',
        fontSize: 'var(--font-size-xs)',
        padding: 'var(--padding-sm)',
        borderBottomLeftRadius: 'var(--border-radius-lg)',
        borderBottomRightRadius: 'var(--border-radius-lg)',
        transition: 'background-color .3s ease-in-out',
        overflow: 'auto'
      }
    }
  })
})

const BrandedDocument = ({ name, imageUrl, onHover }) => {
  const classes = useStyles({ imageUrl })

  return (
    <div className={classes.brandedDocument} onMouseOver={onHover}>
      <div className='__ds-title font-sans'>{name}</div>
    </div>
  )
}

BrandedDocument.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onHover: PropTypes.func
}

BrandedDocument.defaultProps = {
  onHover: () => {}
}

export default BrandedDocument
